<template>
  <div class="DataView">
    <v-row class="DataViews__filter-row">
      <v-col>
        <v-btn text small color="primary" @click="() => this.handleEditDataView(dataView)">
          Edit Data View
        </v-btn>
      </v-col>
      <v-col  class="d-flex justify-end">
        <v-btn icon color="green" @click="getInfo" class="ml-5">
          <v-icon>mdi-cached</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-overlay
      absolute
      :value="dataViewLoading"
      :color="'#ffffff'">
      <v-progress-circular
        :size="150"
        :width="3"
        color="primary"
        indeterminate />
    </v-overlay>
    <v-data-table
      class="DataView__data-table elevation-0"
      :items="this.dataViewRows"
      :headers="this.headers"
      :loading="dataViewLoading"
      :items-per-page="15"
    >
    </v-data-table>

    <edit-data-view :dialog="!!editDataView" @close="() => this.handleEditDataView(null)" />
  </div>
</template>
<script>
import * as moment from 'moment-timezone';
import { createNamespacedHelpers } from 'vuex';
import EditDataView from '@/views/data-views/edit-data-view/edit-data-view-modal.vue';

const {
  mapGetters: dataViewGetters,
  mapActions: dataViewActions,
  mapMutations: dataViewMutations,
} = createNamespacedHelpers('DataView');

export default {
  name: 'DataViewRows',
  components: { EditDataView },
  data() {
    return {
      localTZ: 'UTC',
    };
  },
  async mounted() {
    this.setLocalTimezone();
    await this.getInfo();
  },
  props: ['selectedWorkflowHistory'],
  computed: {
    ...dataViewGetters({
      dataViewItems: 'DATA_VIEW_ITEMS',
      dataView: 'CURRENT_DATA_VIEW',
      dataViewItemsLoading: 'DATA_VIEW_ITEMS_LOADING',
      dataViewLoading: 'CURRENT_DATA_VIEW_LOADING',
      editDataView: 'EDIT_DATA_VIEW',
    }),
    headers() {
      if(!this.dataView?.schema) {
        return [];
      }
      const schema = this.dataView?.schema;
      const headers =  [...Object.keys(schema), 'createdAt'];
      return headers.map((item) => {
        return {
          text: item,
          value: item,
          minWidth: 100,
        }
      })
    },
    dataViewRows() {
      return this.dataViewItems.map((item) => {
        return {
          ...item.data,
          createdAt: this.formatDate(item.createdAt),
        }
      })
    }
  },
  watch: {

  },
  methods: {
    ...dataViewActions(['getDataViewItems', 'getDataView']),
    ...dataViewMutations({
      setEditDataView: 'SET_EDIT_DATA_VIEW',
    }),
    async getInfo() {
      const { dataViewId } = this.$route.params;
      await this.getDataView({ dataViewId: dataViewId });
      await this.getDataViewItems({ dataViewId: dataViewId });
    },
    async handleEditDataView(dataView) {
      this.setEditDataView(dataView);
      if(!dataView) {
        await this.getInfo()
      }
    },
    setLocalTimezone() {
      this.localTZ = moment.tz.guess();
    },
    formatDate(date) {
      if (!date) return '';
      else return moment(date).tz(this.localTZ).format('YYYY-MM-DD HH:mm');
    },
  },
};
</script>

<style scoped>
@import './data-view-page.scss';
</style>
